import { useCustomerQuery, useCustomerSession } from "@graphcommerce/magento-customer";
import Link from "next/link";
import AuthForms from "../AuthForms";
import { useContext } from "react";
import { ModalContext } from "../../context/context";
import { customerDocument } from "../../graphql/login/currentCustomerData.gql";
import { SignOutForm } from "../AuthForms/SignOutForm";
import { Button } from "@mui/material";

export default function MobileLoginBtns() {
  const customer = useCustomerQuery(customerDocument);
  const useModal = useContext(ModalContext);
  return (
    <div className='flex items-center gap-1 text-white'>
      {customer?.data?.customer ?
        <>
          {`سلام ${customer?.data?.customer?.firstname} ${customer?.data?.customer?.lastname} عزیز، خوش آمدید!`}

          <Link href={'/account'}
            className='text-white transition no-underline'>حساب کاربری</Link>
          <span className='text-default-600'> - </span>
          <SignOutForm>
            <Button variant='text' type='submit'
              className='transition text-white no-underline !px-0 !bg-transparent text-sm !max-w-fit !min-w-fit'
            >خروج</Button>

          </SignOutForm>
        </>
        :

        <>
          <Link href={'javascript:void(0)'} className=' text-sm font-bold transition no-underline'>ورود</Link>
          <span> | </span>
          <Link href={'javascript:void(0)'}
            onClick={() => useModal.set && useModal?.set({ content: <AuthForms activeForm='signup' />, open: true, title: '', position: 'center', width: 'max-w-sm' })}

            className='text-sm font-bold transitio no-underline'> ثبت نام</Link>
        </>}

    </div>
  )
}